import * as casesListing from './casesListing';
import * as assets from './cases/assets';
import * as liabilities from './cases/liabilities';
import * as definedBenefits from './cases/definedBenefits';
import * as definedContributions from './cases/definedContributions';
import * as futureAnnuity from './cases/futureAnnuity';
import * as addresses from './cases/addresses';
import * as assurancePolicies from './cases/assurancePolicies';
import * as property from './cases/property';
import * as income from './cases/income';
import * as pepper from './pepper';
import tasks from './cases/tasks';
import vulnerabilities from './cases/vulnerabilities';
import { INCOME_TYPES } from 'modules/cm/api/cases/income/types';
import caseApiMethods from './cases/case';

export const caseApi = caseApiMethods;

export const casesApi = casesListing;
export const assetsApi = (caseId: string) => (applicantId: number) => ({
  postAsset: () => assets.postAsset(caseId, applicantId),
  deleteAsset: (id: number) => assets.deleteAsset(caseId, applicantId, id),
  patchAsset: (id: number, field: string, value: any) => assets.patchAsset(caseId, applicantId, id, field, value),
});
export const liabilitiesApi = (caseId: string) => (applicantId: number) => ({
  postLiability: () => liabilities.postLiability(caseId, applicantId),
  deleteLiability: (id: number) => liabilities.deleteLiability(caseId, applicantId, id),
  patchLiability: (id: number, field: string, value: any) =>
    liabilities.patchLiability(caseId, applicantId, id, field, value),
});
export const definedBenefitsApi = (caseId: string) => (applicantId: number) => ({
  create: () => definedBenefits.post(caseId, applicantId),
  remove: (id: number) => definedBenefits.remove(caseId, applicantId, id),
  update: (id: number, field: string, value: any) => definedBenefits.patch(caseId, applicantId, id, field, value),
});
export const definedContributionsApi = (caseId: string) => (applicantId: number) => ({
  create: () => definedContributions.post(caseId, applicantId),
  remove: (id: number) => definedContributions.remove(caseId, applicantId, id),
  update: (id: number, field: string, value: any) => definedContributions.patch(caseId, applicantId, id, field, value),
});
export const futureAnnuityApi = (caseId: string) => (applicantId: number) => ({
  create: () => futureAnnuity.post(caseId, applicantId),
  remove: (id: number) => futureAnnuity.remove(caseId, applicantId, id),
  update: (id: number, field: string, value: any) => futureAnnuity.patch(caseId, applicantId, id, field, value),
});

export const propertyApi = property;
export const incomeApi = (caseId: string) => (applicantId: number) => ({
  patchIncome: (incomeType: INCOME_TYPES, incomeId: number, field: string, value: any) =>
    income.patchIncome(caseId, applicantId, incomeId, incomeType, field, value),
});

export const addressesApi = (caseId: string) => (applicantId: number) => ({
  post: () => addresses.post(caseId, applicantId),
  remove: (id: number) => addresses.remove(caseId, applicantId, id),
  patch: (id: number, field: string, value: any) => addresses.patch(caseId, applicantId, id, field, value),
});

export const assurancePoliciesApi = (caseId: string) => ({
  post: () => assurancePolicies.post(caseId),
  patch: (id: number, field: string, value: any) => assurancePolicies.patch(caseId, id, field, value),
  remove: (id: number) => assurancePolicies.remove(caseId, id),
});

export const pepperApi = (caseId: string) => ({
  sendToPepper: () => pepper.sendToPepper(caseId),
  validateData: () => pepper.validateData(caseId),
});

export const tasksApi = tasks;
export const vulnerabilitiesApi = vulnerabilities;
